<template>
<main>
    <section id="header" class="my-3">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <h2 class="common-title">{{article.name}}</h2>
                </div>
            </div>
        </div>
    </div>
</section>

<section id="article-content">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="mb-3 text-center">
                    <img class="main-image placed-backg" src="public/images/shared/article-2.png" v-bind:style="{ backgroundImage: 'url('+article.imageUrl+')' }">
                </div>
                <div class="box-text text-justify">
                    <div v-html="article.description"></div>
                </div>
                  
            </div>
        </div>
 <hr>
    </div>
   
</section>



<section id="articles-grid" class="py-3">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <h2 class="common-title py-3">You me also like</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <swiper :options="articlesOption">
                    <swiper-slide v-for="(article, arInx) in articles" :key="arInx" class="col-article-sample">
                        <router-link class="pj-link" :to="'/articles/'+article.id">
                            <div class="box-img">
                              <img class="placed-backg" src="public/images/shared/article.png" v-bind:style="{ backgroundImage: 'url('+article.imgUrl+')' }">
                            </div>
                            <div class="box-info">
                              <h5>{{ article.text }}</h5>
                            </div>
                        </router-link>
                    </swiper-slide>
                    <div class="swiper-pagination"  slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
    </div>
</section>
</main>

</template>

<script>
export default {
    data() {
        return {
        id:"",
        article:{
            name: 'Article title',
            imageUrl: 'public/images/pages/blog/image-5.jpg',
            description: `
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis vitae urna et ex condimentum commodo. Ut efficitur odio vitae finibus ultricies. Integer ac ultrices nisi. Ut tincidunt auctor lectus ut dapibus. Pellentesque fermentum interdum risus et facilisis. Cras interdum metus at dui aliquet, sit amet consectetur augue semper. In tincidunt sit amet dolor in feugiat. Pellentesque sagittis turpis vitae facilisis posuere. Sed elit libero, lacinia ut varius ut, vulputate et orci. Sed vel nisi malesuada, luctus eros in, cursus lorem. Nulla ac maximus sem, nec imperdiet sem. Cras et lectus sit amet erat fringilla vestibulum. Cras orci arcu, dictum et massa sit amet, ultricies volutpat lectus.<br>
                    <br>
                    Pellentesque mattis et urna commodo elementum. Integer eget rhoncus sapien, quis tristique ipsum. Aenean eget finibus magna. Aliquam posuere, risus id aliquet dignissim, odio metus imperdiet libero, porttitor pharetra risus diam nec lectus. Pellentesque consequat nulla ac justo porttitor, ut euismod elit tempus. Morbi lobortis nisi ac dui gravida finibus. Nam vestibulum aliquam venenatis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In a ultrices justo.
                </p>
            `,
        },
        articles: [
            { id: 1, imgUrl: 'public/images/pages/blog/image-1.jpg', text: 'Advantages of PVC windows', },
            { id: 1, imgUrl: 'public/images/pages/blog/image-2.jpg', text: 'Advantages of PVC Eslowindows',},
            { id: 1, imgUrl: 'public/images/pages/blog/image-3.jpg', text: 'Tips on how to choose the right PVC',},
        ],

        articlesOption: {
        loop:true,
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },
        }
    },
    watch:{
        "$route.params.id":function()
        {
            this.article = {};
            this.id = this.$route.params.id;
            this.getArticle(this.id);
        },
        '$i18n.locale': function (newVal, oldVal) {
            this.getArticle(this.id);
        }
        
    },
    methods: {
        getArticle:function(id){
          axios.get(tools.url('/articleFront/'+id)).then(
            ({data}) =>{
              this.article=data[this.$i18n.locale];
            }
          );
        },
        getArticles: function(){
        axios.get(tools.url('/articlesFront')).then(
          ({data}) =>{
            this.articles=data[this.$i18n.locale];
          });
      },
    },
    mounted() {
        
        // if (this.$route.params.id) {
        //     this.id = this.$route.params.id;
        //     this.getArticle(this.id);
        // }
        // this.getArticles();
        
    }
}
</script>